export const getSkillsData = (t) => ({
  languages: {
    title: t('skills.languages'),
    icon: "💻",
    skills: ["JavaScript (ES6+)", "TypeScript", "PHP", "HTML5", "CSS3", "SQL"]
  },
  frontend: {
    title: t('skills.frontend'),
    icon: "🎨",
    skills: [
      "Next.js (SSR/SSG)",
      "React.js (Hooks, Context API)",
      "React Native & Expo",
      "Tailwind CSS",
      "Responsive Design",
      "Blade Templates",
      "Redux/Zustand"
    ]
  },
  backend: {
    title: t('skills.backend'),
    icon: "⚙️",
    skills: [
      "NestJS (Modules, Guards, Interceptors)",
      "Node.js & Express.js",
      "Laravel (Eloquent ORM, Middleware)",
      "RESTful API Design",
      "GraphQL",
      "WebSocket (Real-time)",
      "Microservices Architecture",
      "Authentication (JWT, OAuth)"
    ]
  },
  database: {
    title: t('skills.database'),
    icon: "🗄️",
    skills: [
      "MySQL (Query Optimization)",
      "PostgreSQL",
      "MongoDB",
      "Redis (Caching)",
      "Database Design & Normalization",
      "Prisma ORM"
    ]
  },
  devops: {
    title: t('skills.devops'),
    icon: "☁️",
    skills: [
      "Docker & Docker Compose",
      "AWS (EC2, S3, RDS)",
      "CI/CD Pipelines",
      "GitHub Actions",
      "Nginx",
      "Linux/Ubuntu Server"
    ]
  },
  testing: {
    title: t('skills.testing'),
    icon: "✅",
    skills: [
      "Jest & Testing Library",
      "Unit & Integration Testing",
      "E2E Testing",
      "TDD/BDD Practices",
      "Code Review",
      "Performance Optimization"
    ]
  },
  tools: {
    title: t('skills.tools'),
    icon: "🛠️",
    skills: [
      "Git & GitHub",
      "Jira & Confluence",
      "Agile/Scrum",
      "VS Code",
      "Postman/Insomnia",
      "Figma (Design Collaboration)"
    ]
  }
});
